export let TwilioDeviceStatus;
(function (TwilioDeviceStatus) {
  TwilioDeviceStatus["REGISTERING"] = "registering";
  TwilioDeviceStatus["REGISTERED"] = "registered";
  TwilioDeviceStatus["UNREGISTERED"] = "unregistered";
  TwilioDeviceStatus["DESTROYED"] = "destroyed";
})(TwilioDeviceStatus || (TwilioDeviceStatus = {}));